export default {
    customer: {
        customerManagement: 'Customer Management',
        dataStorage: "Data Storage",
        databases: "Databases",
        rniManagement: 'RNI Management',
        manageReleases:'Manage Releases',
        enableFlow:'Enable Flow',
        disableFlow: 'Disable Flow',
        rniOnOffFlowHint:'Note: Turning on/off one rni flow might affect multiple customers.',
        customerDetails: 'Customer Details',
        towers: 'Base Stations',
        endpoints: 'Endpoints',
        routes: 'Routes',
        towersHistory: 'Base Station History',
        history: 'History',
        general: 'General',
        metrics: 'Metrics',
        dataFlow: 'Data Flow',
        security: 'Security',
        securityConfiguration: 'Security Configuration',
        createCustomer: 'Create Customer',
        updateCustomer: 'Update Customer',
        deleteCustomer: 'Delete Customer',
        updateSecurity: 'Update Security',
        customer: 'Customer',
        customers: 'Customers',
        numBaseStations: "Base Station Count",
        numRadios: "Radio Count",
        numRoutes: "Route Count",
        name: 'Name',
        rniName: 'RNI Name',
        rniCustomer: 'RNI Customer ID',
        rniVersion: 'RNI Version',
        streamerVersion: "Streamer Version",
        flow:'Flow',
        rniVersionNotProvided: 'RNI Version Not Provided',
        rniCustomerHeader: 'RNI Customer ID',
        rniId: 'RNI ID',
        displayName: 'Display Name',
        description: 'Description',
        descriptionOptional: 'Description (optional)',
        staleTimeTowers: 'Base Station Stale Time',
        staleTimeEndpoints: 'Endpoint Stale Time',
        staleTimeTowersMinutes: 'Base Station Stale Time (minutes)',
        staleTimeEndpointsMinutes: 'Endpoint Stale Time (minutes)',
        staleTimeTowersHeader: 'Base Station Stale Time',
        staleTimeEndpointsHeader: 'Endpoint Stale Time',
        timeUnit: 'Time Unit',
        tmAdminRotationPolicy: 'tmadmin Rotation Policy',
        tmAdminPolicy: {
            TWENTY_FOUR_HOUR: "24 Hours",
            SEVEN_DAY: "7 Days",
        },
        dataRetention: 'Data Retention',
        dataRetentionDays: 'Data Retention (days)',
        dataRetentionHeader: 'Data Retention</br>(days)',
        lastHeard: 'Last Heard',
        firstHeard: 'First Heard',
        modDate: 'Last Modified Date',
        modUser: 'Last Modified By',
        modDateHeader: 'Modified Date',
        modUserHeader: 'Modified User',
        msgsPerSecond: 'RNI 4 Messages/Sec',
        heliosMsgsPerSecond: 'RNI 5 Messages/Sec',
        webHost: 'RNI Host Name',
        multipleSelected: '(Multiple Selected)',
        useRniHost: '(Use RNI Host)',
        securityUser: 'User',
        securityPassword: 'Password',
        publicKey: 'Public Key',
        securityStatus: 'Status',
        securityConfigStatus: 'Security Config Status',
        rniExport : "RNI Export",
        rniExportData: {
            endpoint: {
                status: "RNI Endpoint Export Status",
                lastExportDate: "RNI Endpoint Last Export Date",
                nextExportDate: "RNI Endpoint Next Export Date",
                recordCount: "RNI Endpoint Export Record Count"
            },
            tower: {
                status: "RNI Tower Export Status",
                lastExportDate: "RNI Tower Last Export Date",
                nextExportDate: "RNI Tower Next Export Date",
                recordCount: "RNI Tower Export Record Count"
            },
            risrds: {
                status: "RNI RIS Export Status",
                lastExportDate: "RNI RIS Last Export Date",
                nextExportDate: "RNI RIS Next Export Date",
                recordCount: "RNI RIS Export Record Count"
            }
        },
        securityMessage: 'Message',
        customerCreated: 'Customer \'{name}\' was successfully created',
        customerUpdated: 'Customer \'{name}\' was successfully updated',
        rniFlowControlStatusUpdated: '\{num}\ RNI(s) were successfully updated',
        securityUpdateRequested: {
            none: 'No security update requested',
            single: "Security update for customer '{name}' has been requested. It may take a few minutes to complete.",
            many: "Security updates for '{num}' customers have been requested. They may take a few minutes to complete."
        },
        valueIsRequired: 'Value is required',
        customerMustBeLowerCase: 'Customer must be lower case',
        deleteCustomerPrompt: 'Are you sure you want to delete customer \'{name}\'?',
        disableRNIFlow: 'Are you sure you want to disable the selected RNI(s)?',
        customerDeleted: 'Customer \'{name}\' was successfully deleted',
        rniFlowDisabled: 'No RNI flow was disabled | 1 RNI flow was successfully disabled | {num} RNI flows were successfully disabled',
        rniFlowEnabled: 'No RNI flow was enabled | 1 RNI flow was successfully enabled | {num} RNI flows were successfully enabled',
        clickPasswordIconTooltipShow: 'Click to show password',
        clickPasswordIconTooltipHide: 'Click to hide password',
        getCustomersError: 'Error retrieving customers',
        getCustomerRatesError: 'Error retrieving customer data rates',
        getCustomerForUpdateError: 'Error retrieving customer \'{name}\' for update',
        deleteCustomerError: 'Error deleting customer \'{name}\'',
        disableFlowError: 'Error disabling flow of RNI \'{name}\'',
        enableFlowError: 'Error enabling flow of RNI \'{name}\'',
        retrieveDetailsError: 'Error retrieving customer \'{name}\'',
        createCustomerError: 'Error creating customer',
        updateCustomerError: 'Error updating customer',
        updateRniFlowControlStatusError: 'Error updating rni flow control status',
        duplicateCustomerNameError: 'Duplicate customer name: \'{name}\'',
        rniIdAlreadyMappedError: 'The RNI ID and RNI Customer combination have already been mapped',
        getSecurityError: 'Error retrieving security data for customer \'{name}\'',
        getSecurityForUpdateError: 'Error retrieving security data for update',
        updateSecurityError: 'Error updating security for customer \'{name}\'',
        getAllSecurityError: 'Error retrieving security status for customer list',
        staleTimeTowerTooShort: 'Base Station Stale Time must be at least 5 minutes',
        staleTimeEndpointTooShort: 'Endpoint Stale Time must be at least 1 hour',
        securityStatuses: {
            IN_PROGRESS: 'In Progress',
            SUBMITTED: 'Submitted',
            COMPLETED: 'Completed',
            FAILED: 'Failed'
        },
        securityCodes: {
            GENERIC_FAILURE: 'An unknown error occurred',
            ERROR_CREATING_CLIENT_REGISTRATION: 'Error creating client registration',
            ERROR_GETTING_SECURITY_CONFIGURATION: 'Unable to get the security configuration',
            ERROR_CREATING_REALM: 'Error creating the realm',
            ERROR_CREATING_CLIENT: 'Error creating the client',
            ERROR_ACCESS_TOKEN: 'Error getting an access token',
            COPYING_SCRIPT_TO_RNI: 'Copying script to RNI',
            FAILED_TO_COPY_SCRIPT_TO_RNI: 'Failed to copy script to RNI',
            SCRIPT_COPIED_TO_RNI: 'Script successfully copied to RNI',
            SCRIPT_CONVERTED_TO_UNIX: 'Script converted to unix format',
            SCRIPT_RUNNING: 'Script is running on RNI',
            SCRIPT_FAILED_TO_EXECUTE: 'Script failed to execute properly on RNI',
            SCRIPT_SUCCESSFULLY_EXECUTED: 'Script successfully executed on RNI',
            SCRIPT_RESULTS_COPIED_BACK: 'Script results successfully copied back from RNI',
            SCRIPT_CLEANED_UP_RNI: 'Files successfully cleaned up on RNI',
            PROCESS_COMPLETED_SUCCESSFULLY: 'Security processing completed successfully',
            ERROR_COPYING_FILE_TO_RNI: 'Error copying file to RNI'
        },
        switchDesc: 'Click to switch customers',
        dialogTitle: 'Switch Customers',
        picker: 'Active Customer',
        other: 'Other',
        buddyThresholdsSubtitle: 'Buddy Thresholds',
        tuningThresholdsSubtitle: 'Tuning Thresholds',
        updateThresholds: 'Update Thresholds',
        minValueRequired: 'Minimum required value is {value}',
        maxValueRequired: 'Maximum value supported is {value}',
        valueRequired: 'Value is required',
        tuneThresholds: {
            analysisDays: {
                label: 'Analysis Days',
                hint: "Number of days to check the baseStationLag time series for data."
            },
            readAnalysisDays: {
                label: 'Read Analysis Days',
                hint: "Number of days of reads data to use for determining read gaps and throughput calculations.",
            },
            directRouteDays: {
                label: 'Direct Route days',
                hint: "Number of days back to look for a direct route: directRouteCutOffDate.",
            },
            freqHysteresisDays: {
                label: 'Frequency Hysteresis Days',
                hint: "Number of days to check for frequency change.",
            } ,
            minDownLinkDirectRoutess: {
                label: 'Min Downlink Direct Route Signal Strength',
                hint: "Downlink route's minimum average signal strength. Used in determining isSuspectedORD",
            },
            tempOrdUplinkRouteDays: {
                label: 'Temp ORD Uplink Route Days',
                hint: 'Number of uplink route days used to determine a Temp ORD eligibility'
            },
            tempOrdMinDownlinkDirectRouteSNR: {
                label: 'Temp ORD Min Downlink Direct Route SNR',
                hint: "Downlink route's minimum SNR when determining Temp ORD"
            },
            tuningUplinkBestTowerSNRThreshold: {
                label: 'Best Base Station SNR Threshold (dB)',
                hint: "SNR Threshold for a base station to be considered in the best base station calculation for tuning eligibility."
            }
        },
        buddyThresholds: {
            minAllowableDistanceBetweenStaticRebroadcasters: {
                label: 'Min Allowable Distance Between Static Rebroadcasters',
                hint: "Minimum allowable distance between static rebroadcasters",
            },
            minBuddyToTowerSNR: {
                label: 'Min Buddy To Base Station Signal to Noise Ratio',
                hint: "Minimum SNR (Signal-to-Noise Ratio) for buddies to the tower",
            },
            minORDToBuddySignalStrength: {
                label: 'Min ORD To Buddy Signal Strength ',
                hint: "Minimum ORD to buddy signal strength"
            },
            staticRebroadcasterCoverageOverlapQuota: {
                label: 'Static Rebroadcaster Coverage Overlap Quota',
                hint: "Coverage overlap quota for static rebroadcasters"   
            },
            staticRebroadcasterMinORDCoverageQuota: {
                label: 'Static Rebroadcaster Min ORD Coverage Quota',
                hint: "Minimum ORD coverage quota for static rebroadcasters",
            }
        },
        staleFilters: {
            fifteenMinutesPlus: "15+ Minutes",
            thirtyMinutesPlus: "30+ Minutes",
            onePlusHr: "1+ Hour",
            fourPlusHr: "4+ Hour"
        },
        features: "Features",
        featuresList: {
            NETMET: "Network Metrics",
            NETTUNE: "Network Tuning",
            NETCONFIGURE: "Network Configuration"
        },
        rniExportStatus: {
            IN_PROGRESS: "In Progress",
            COMPLETE: "Complete"
        },
        etfControl: "Enable Tuning Feature",
        ecfControl: "Enable Configuration Feature",
        enableLatLongOTAFlag: "Enable Radio Lat/Long Update Via OTA Messages",
        rtMinSampleCount: "Min Samples (Up/Down)",
        rapidTuneConfiguration: {
            enabled: 'Enable Rapid Tuning',
            useInstallChannels: "Enable",
            GLOBAL_CONFIG: {
                title: 'Global Configuration',
                description: 'Global configuration settings that apply across install and bulk channel configurations',
            },
            INSTALL_CHANNEL_CONFIG: {
                title: 'Install Channel Configuration',
                description: 'If enabled, configurations to move radios from the Admin Channel to the Install Channel(s), default is disabled',
                enableControlHint: 'Enable or Disable moving radios from Admin Channel to Install Channel before moving to Bulk Channels'
            },
            BULK_CHANNEL_CONFIG: {
                title: 'Bulk Channel Configuration',
                description: 'Configurations to move radios from the Admin or Install Channel to the Bulk Channels',
            },
            rapidTunePeriod: {
                label: 'Sweep Interval Seconds',
                labelShort: 'Sweep Interval',
                hint: 'Frequency of Rapid Tune "sweeps" to check and command CommsHubs.',
                suffix: '',
            },
            minUplinkSamples: {
                label: 'Min Uplink Samples',
                hint: 'Required uplink messages from a tower for Rapid Tuning eligibility.',
                suffix: '',
            },
            minDownlinkSamples: {
                label: 'Min Downlink Samples',
                hint: 'Required downlink samples (timesyncs or Tower Reports) for Rapid Tuning eligibility.',
                suffix: '',
            },
            minUplinkSnr: {
                label: 'Min Uplink SNR',
                hint: 'Minimum average uplink SNR for Rapid Tuning eligibility on a TGB.',
                suffix: '',
            },
            minDownlinkSnr: {
                label: 'Min Downlink SNR',
                hint: 'Minimum average downlink SNR for Rapid Tuning eligibility on a TGB.',
                suffix: '',
            },
            maxUplinkStdDev: {
                label: 'Max Uplink Std Dev',
                hint: 'Allowable uplink SNR deviation for Rapid Tuning eligibility.',
                suffix: '',
            },
            expirationIntervalMinutes: {
                label: 'Expiration Interval Minutes',
                labelShort: 'Expiration Interval',
                hint: 'Time before an untuned CommsHub expires from Rapid Tune.',
                suffix: '',
            },
            minimumInstallTuningMinutes: {
                label: 'Min Tuning Threshold Minutes',
                hint: 'Time a CommsHub is heard by NCS before being eligible for tuning to this channel.',
                suffix: '',
            },
            minMinutesBeforeTuning: {
                label: 'Min Threshold Minutes on Admin Channel',
                hint: 'Time a CommsHub is heard by NCS before being eligible for tuning from admin channel to install channel.',
                suffix: '',
            },
            historyRetentionDays: {
                label: 'History Retention Days',
                hint: 'Number of days to retain rapid tuning history.',
                suffix: '',
            },
            minutesOnInstallBeforeBulkTuning: {
                label: 'Min Threshold Minutes on Install Channel',
                hint: 'Time a CommsHub is heard by NCS before being eligible for tuning from install channel to bulk channel.',
                suffix: '',
            },
        },
        updateEtlTowerChannelsTaskConfiguration: 'Update ETL Tower Channels Task Configuration',
        deleteOfStalesTowerChannels: 'Delete Stale Tower Channels',
        exportPrimaryChannelsOnly: 'Export Primary Channels Only',
        updateDlogInfoMsg: "Customer changes require a user to logout/login (or browser refresh) to be seen",
        towerCmdMax: "Max Commands Sent per Base Station per Hour",
        twrCmdsMinError: "Minimum commands per base station per hour must be > 0",
        twrCmdsMaxError: "Maximum commands per base station per hour must be <= 999",
        streamerToken: {
            title: 'Streamer Onboarding Token',
            description: 'Use this token to allow a new streamer to connect to NCS. Place the Token string into the bootstrap file on each NC you want to add to NCS. This token is valid until {expirationTime}.',
            bootstrapPathLabel: 'Bootstrap File Path',
            tokenLabel: 'Token',
            errorFetchingToken: 'Error retrieving token',
            action: 'Get Streamer Token',
            copyPathTooltip: 'Copy Path',
            copyTokenTooltip: 'Copy Token',
        }
    }
}
